_ = require('underscore');
module.exports = {
    "carouselBinTemplate": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="carousel-bin">\n        ';
 _.each(obj.images, function(src, index) { ;
__p += '\n            <div class="carousel-bin-image-wrapper" data-index="' +
((__t = ( index )) == null ? '' : __t) +
'">\n                <div class="carousel-bin-image" style="background-image: url(' +
((__t = ( src )) == null ? '' : __t) +
');" ></div>\n            </div>\n        ';
 }); ;
__p += '\n    </div>\n';
return __p
}
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/CarouselBin/CarouselBin-template.html
// module id = 1892
// module chunks = 4 7